import { render, staticRenderFns } from "./StepsSecondAddCourse.vue?vue&type=template&id=6cd8d2e3&scoped=true"
import script from "./StepsSecondAddCourse.vue?vue&type=script&lang=js"
export * from "./StepsSecondAddCourse.vue?vue&type=script&lang=js"
import style0 from "./StepsSecondAddCourse.vue?vue&type=style&index=0&id=6cd8d2e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd8d2e3",
  null
  
)

export default component.exports